import { generatePath } from 'react-router';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';
import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';
import Auth from '@Services/Auth';
import { trackRegistrationErrors } from '../Register/analytics';

export const openConfirmationEmailSentDialog =
  ({ email }) =>
  () => {
    history.push({
      pathname: paths.CHECK_INBOX,
      state: { email },
    });
  };

export const openConfirmationSuccessDialog =
  ({ regId, shibbolethToken } = {}) =>
  () => {
    const location = { pathname: paths.REGISTRATION_CONFIRMED };
    if (regId || shibbolethToken) {
      location.state = { regId, shibbolethToken };
    }
    history.push(location);
  };

export const confirmationFromEmailLink =
  ({ regId, shibbolethToken }) =>
  async (dispatch) => {
    try {
      await MessageBroker.send(RequestUrls.userRegisterConfirmationFromEmailLink, { regId });

      if (Auth.getAccessToken()) {
        await Auth.logout();
      }

      dispatch(openConfirmationSuccessDialog({ regId, shibbolethToken }));
    } catch (error) {
      if (error.type !== 'CHOICE') {
        Logger.error(error);
        history.push({
          pathname: generatePath(paths.LOGIN),
        });
        setTimeout(() => trackRegistrationErrors([error.message], false), 1000); // call after redirect and AA init
      }
    }
  };
